import { App as AntdApp, ConfigProvider } from "antd";
// AOS (Animate-On-Scroll) is disabled app-wide — the fade-up effect was
// hiding content below the fold until the user scrolled, and the
// cascading delays made every screen feel laggy. Leaving the import +
// init commented (not deleted) so they're easy to flip back on. See
// also: src/assets/css/index.css (aos.css import is commented there).
// import Aos from "aos";
// import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import InternetConnection from "./components/common/InternetConnection";
import { AuthProvider } from "./components/context/AuthContext";
import { GlobalProvider } from "./components/context/GlobalContext";
import { MainContainer } from "./components/layouts/MainContainer";
import { antdTheme, muiTheme } from "./constants/theme";
import { ThemeProvider } from "@mui/material";
import { ModalProvider } from "./components/context/ModalContext";
import { ConfettiView } from "./components/elements/ConfettiView";

function App() {
  // AOS init removed — see comment on the import above for context.
  // useEffect(() => {
  //   Aos.init({
  //     duration: 350,
  //     delay: 0,
  //     offset: 60,
  //     easing: "ease-out",
  //     once: true,
  //   });
  //   Aos.refresh();
  // }, []);

  return (
    <ThemeProvider theme={muiTheme}>
      <ConfigProvider theme={antdTheme}>
        <AntdApp>
          <GlobalProvider>
            <BrowserRouter>
              <AuthProvider>
                <ModalProvider>
                  <>
                    <ConfettiView />
                    <InternetConnection />
                    <MainContainer />
                  </>
                </ModalProvider>
              </AuthProvider>
            </BrowserRouter>
          </GlobalProvider>
        </AntdApp>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;
